import { Button, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { CalculatorLeadErrorDialog } from "web_myplann/Calculators/Components/CalculatorLeadErrorDialog";
import type { CalculatorLeadState } from "web_myplann/Calculators/Types/CalculatorLeadState";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LeadSentDialog } from "web_myplann/Shared/Components/LeadSentDialog";

type Props = {
	hint: string;
	lead: CalculatorLeadState;
};

export const CalculatorLeadActions: FC<Props> = ({ hint, lead }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography
				variant="note"
				textAlign="center"
				mt={theme.spacingTokens.lg}
				pt={theme.spacingTokens.lg}
				borderTop={theme.colors.border.solid(theme.hero.divider)}
			>
				{hint}
			</Typography>
			<Button
				variant="primary"
				type="submit"
				loading={lead.isPending}
				sx={{ mt: theme.spacingTokens.sm }}
			>
				{t(Resources.Calculators.Result.ContactAdvisor)}
			</Button>
			<LeadSentDialog
				open={lead.isSent}
				onClose={lead.closeDialog}
				title={t(Resources.Calculators.Result.SentTitle)}
				description={t(Resources.Calculators.Result.SentText)}
			/>
			<CalculatorLeadErrorDialog
				open={lead.isFailed}
				onClose={lead.closeDialog}
			/>
		</>
	);
};
